import type { ReactNode } from 'react';

/**
 * Pulsing placeholder block for loading states. Drop in anywhere a
 * Loading… text or empty value would otherwise sit. Sized via Tailwind
 * classes (h-4 w-24, etc.).
 */
export function Skeleton({ className = '' }: { className?: string }) {
  return <div className={`animate-pulse bg-cream-deep rounded ${className}`} />;
}

/** A row of N table-cell-shaped skeletons, useful as <tbody> placeholder. */
export function SkeletonRows({ rows = 6, cols = 4 }: { rows?: number; cols?: number }) {
  const arr = Array.from({ length: rows });
  const cells = Array.from({ length: cols });
  return (
    <>
      {arr.map((_, r) => (
        <tr key={r} className="border-b border-line-soft">
          {cells.map((_, c) => (
            <td key={c} className="px-3 py-3.5">
              <Skeleton className={'h-4 ' + (c === 0 ? 'w-40' : c === cols - 1 ? 'w-16' : 'w-24')} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}

/** Full-page card with skeleton lines, useful for empty page loading. */
export function SkeletonCard({ children }: { children?: ReactNode }) {
  return (
    <div className="bg-white border border-line rounded-lg p-5 space-y-3">
      <Skeleton className="h-4 w-32" />
      <Skeleton className="h-7 w-20" />
      <Skeleton className="h-3 w-40" />
      {children}
    </div>
  );
}
